import { render, staticRenderFns } from "./BulkLoad.vue?vue&type=template&id=325131f2&"
import script from "./BulkLoad.vue?vue&type=script&lang=js&"
export * from "./BulkLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports